module.exports = __webpack_public_path__ + "static/gallery-23-ae540142872e74edd36797900c321ee3.jpg";